import { CurrencyCode, PlatformType } from '@buggy/shared'
import demoPostSrc1 from '@/assets/images/auto-report/demo/cooperation/1.png'
import demoPostSrc2 from '@/assets/images/auto-report/demo/cooperation/2.png'
import demoPostSrc3 from '@/assets/images/auto-report/demo/cooperation/3.png'
import demoPostSrc4 from '@/assets/images/auto-report/demo/cooperation/4.png'
import demoPostSrc5 from '@/assets/images/auto-report/demo/cooperation/5.png'
import demoPostSrc6 from '@/assets/images/auto-report/demo/cooperation/6.png'
import { Gender } from '@/constants/gender'
import {
  makeBrandInfo6,
  makeBrandInfo7,
  makeBrandInfo8,
  makeKolInfo1,
  makeKolInfo10,
  makeKolInfo2,
  makeKolInfo3,
  makeKolInfo4,
  makeKolInfo5,
  makeKolInfo6,
  makeKolInfo7,
  makeKolInfo8,
  makeKolInfo9,
} from '@/constants/mock-data/kol-info'
import { PostType } from '@/constants/post-type'
import { SupportedLanguages } from '@/i18n/config'
import { Post } from '@/types/schema/ai-search'
import {
  BehaviorRecommendationResponse,
  KeywordRecommendationResponse,
} from '@/types/schema/api/ai-search'
import { PlatformShortcode } from '@/utils/convert-platform'

export const mockPostIdPrefix = '@@@_mock_post'
export const mockEmptyPostIdPrefix = `${mockPostIdPrefix}_empty`
const mockEmptyPostList: Post[] = [
  {
    publish_time: '2024-07-03T11:32:01Z',
    title_content: '',
    post_id: `${mockEmptyPostIdPrefix}_1`,
    post_type: PostType.Image,
    platform_type: PlatformType.Instagram,
    thumbnail: demoPostSrc1,
    crawled_id: '',
    ig_post_id: '',
    link: '',
  },
  {
    publish_time: '2024-07-03T11:32:01Z',
    title_content: '',
    post_id: `${mockEmptyPostIdPrefix}_2`,
    post_type: PostType.Image,
    platform_type: PlatformType.Instagram,
    thumbnail: demoPostSrc2,
    crawled_id: '',
    ig_post_id: '',
    link: '',
  },
  {
    publish_time: '2024-07-03T11:32:01Z',
    title_content: '',
    post_id: `${mockEmptyPostIdPrefix}_3`,
    post_type: PostType.Image,
    platform_type: PlatformType.Instagram,
    thumbnail: demoPostSrc3,
    crawled_id: '',
    ig_post_id: '',
    link: '',
  },
]

const makeFakeBehaviorRecommendationData = (
  locale?: SupportedLanguages,
): BehaviorRecommendationResponse => {
  const kolInfo1 = makeKolInfo1(locale)
  const kolInfo2 = makeKolInfo2(locale)
  const kolInfo3 = makeKolInfo3(locale)
  const kolInfo4 = makeKolInfo4(locale)
  const kolInfo5 = makeKolInfo5(locale)
  const kolInfo6 = makeKolInfo6(locale)
  const kolInfo7 = makeKolInfo7(locale)
  const kolInfo8 = makeKolInfo8(locale)
  const kolInfo9 = makeKolInfo9(locale)
  const kolInfo10 = makeKolInfo10(locale)
  const brandInfo6 = makeBrandInfo6(locale)
  const brandInfo7 = makeBrandInfo7(locale)
  const brandInfo8 = makeBrandInfo8(locale)

  return {
    data: {
      kols: [
        {
          kol_uuid: kolInfo1.id,
          hash_kol_datahub_identity_id: kolInfo1.id,
          names: [kolInfo1.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'Influencer',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo7.id,
              name: brandInfo7.name,
              kol_type: 'Influencer',
              rank: 2,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo8.id,
              name: brandInfo8.name,
              kol_type: 'Influencer',
              rank: 3,
            },
          ],
          sponsored_rate: 0.1,
          audience_gender: Gender.Female,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-07-03T11:32:01Z',
              title_content: '',
              post_id: 'C89X8a-vCZ_',
              post_type: PostType.Image,
              platform_type: PlatformType.Instagram,
              thumbnail: demoPostSrc1,
              crawled_id: '3291079932',
              ig_post_id: '3403982200570127999',
              link: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '3403264375228512654',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: 'C860usCPLmO',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc3,
              crawled_id: '3291079932',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '以旅遊、美食和生活風格的內容而受歡迎，最近發布了超商隱藏調酒喝法，單支影片瀏覽量更突破 40 萬。',
        },
        {
          kol_uuid: kolInfo2.id,
          hash_kol_datahub_identity_id: kolInfo2.id,
          names: [kolInfo2.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.21623521058003817,
          max_engagement_rate_3m: 0.06963755199049317,
          max_follow_count_growth_rate_3m: 0.17073170840740204,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 23800,
              engagement_rate_3m: 0.004055259108346518,
              follow_count_growth_rate_3m: -0.014945652335882187,
              view_rate_3m: 0.21623521058003817,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 999,
              engagement_rate_3m: 0.06963755199049317,
              follow_count_growth_rate_3m: 0.14817847311496735,
              view_rate_3m: 0,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 42000,
              engagement_rate_3m: 0.008863046757164404,
              follow_count_growth_rate_3m: 0.17073170840740204,
              view_rate_3m: 0.022827549019607842,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'brand',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo8.id,
              name: brandInfo8.name,
              kol_type: 'Influencer',
              rank: 3,
            },
          ],
          sponsored_rate: 0.00123,
          audience_gender: Gender.Male,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-06-23T06:58:12Z',
              title_content: "I'm not to be messed with!",
              post_id: 'NAb9DsmZT3I',
              post_type: PostType.Image,
              platform_type: 0,
              thumbnail: demoPostSrc5,
              crawled_id: 'UCvw1LiGdyulhnGksJlGWB6g',
              link: 'https://www.youtube.com/watch?v=NAb9DsmZT3I',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc6,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: '7321724200497040646',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '樂於分享超商、連鎖速食店創意吃法等等影片，以幽默搞笑的短片和生活日常分享而受歡迎。',
        },
        {
          kol_uuid: kolInfo3.id,
          hash_kol_datahub_identity_id: kolInfo3.id,
          names: [kolInfo3.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 12973430,
          max_view_rate_3m: 0.21623521058003817,
          max_engagement_rate_3m: 0.06963755199049317,
          max_follow_count_growth_rate_3m: 0.17073170840740204,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 33800,
              engagement_rate_3m: 0.004055259108346518,
              follow_count_growth_rate_3m: -0.014945652335882187,
              view_rate_3m: 0.21623521058003817,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10000,
              engagement_rate_3m: 0.06963755199049317,
              follow_count_growth_rate_3m: 0.14817847311496735,
              view_rate_3m: 0,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 42000,
              engagement_rate_3m: 0.008863046757164404,
              follow_count_growth_rate_3m: 0.17073170840740204,
              view_rate_3m: 0.022827549019607842,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'brand',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo7.id,
              name: brandInfo7.name,
              kol_type: 'brand',
              rank: 2,
            },
          ],
          sponsored_rate: 0.03,
          audience_gender: Gender.Female,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-06-23T06:58:12Z',
              title_content: "I'm not to be messed with!",
              post_id: 'NAb9DsmZT3I',
              post_type: PostType.Image,
              platform_type: 0,
              thumbnail: demoPostSrc2,
              crawled_id: 'UCvw1LiGdyulhnGksJlGWB6g',
              link: 'https://www.youtube.com/watch?v=NAb9DsmZT3I',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc3,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: '7321724200497040646',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc4,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '樂於分享超商、連鎖速食店創意吃法等等影片，以幽默搞笑的短片和生活日常分享而受歡迎。',
        },
        {
          kol_uuid: kolInfo4.id,
          hash_kol_datahub_identity_id: kolInfo4.id,
          names: [kolInfo4.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'Influencer',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo7.id,
              name: brandInfo7.name,
              kol_type: 'Influencer',
              rank: 2,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo8.id,
              name: brandInfo8.name,
              kol_type: 'Influencer',
              rank: 3,
            },
          ],
          sponsored_rate: 0.1,
          audience_gender: Gender.Female,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-07-03T11:32:01Z',
              title_content: '',
              post_id: 'C89X8a-vCZ_',
              post_type: PostType.Image,
              platform_type: PlatformType.Instagram,
              thumbnail: demoPostSrc1,
              crawled_id: '3291079932',
              ig_post_id: '3403982200570127999',
              link: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '3403264375228512654',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: 'C860usCPLmO',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc3,
              crawled_id: '3291079932',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '以旅遊、美食和生活風格的內容而受歡迎，最近發布了超商隱藏調酒喝法，單支影片瀏覽量更突破 40 萬。',
        },
        {
          kol_uuid: kolInfo5.id,
          hash_kol_datahub_identity_id: kolInfo5.id,
          names: [kolInfo5.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.21623521058003817,
          max_engagement_rate_3m: 0.06963755199049317,
          max_follow_count_growth_rate_3m: 0.17073170840740204,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 23800,
              engagement_rate_3m: 0.004055259108346518,
              follow_count_growth_rate_3m: -0.014945652335882187,
              view_rate_3m: 0.21623521058003817,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 999,
              engagement_rate_3m: 0.06963755199049317,
              follow_count_growth_rate_3m: 0.14817847311496735,
              view_rate_3m: 0,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 42000,
              engagement_rate_3m: 0.008863046757164404,
              follow_count_growth_rate_3m: 0.17073170840740204,
              view_rate_3m: 0.022827549019607842,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'brand',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo8.id,
              name: brandInfo8.name,
              kol_type: 'Influencer',
              rank: 3,
            },
          ],
          sponsored_rate: 0.00123,
          audience_gender: Gender.Male,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-06-23T06:58:12Z',
              title_content: "I'm not to be messed with!",
              post_id: 'NAb9DsmZT3I',
              post_type: PostType.Image,
              platform_type: 0,
              thumbnail: demoPostSrc5,
              crawled_id: 'UCvw1LiGdyulhnGksJlGWB6g',
              link: 'https://www.youtube.com/watch?v=NAb9DsmZT3I',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc6,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: '7321724200497040646',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '樂於分享超商、連鎖速食店創意吃法等等影片，以幽默搞笑的短片和生活日常分享而受歡迎。',
        },
        {
          kol_uuid: kolInfo6.id,
          hash_kol_datahub_identity_id: kolInfo6.id,
          names: [kolInfo6.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 12973430,
          max_view_rate_3m: 0.21623521058003817,
          max_engagement_rate_3m: 0.06963755199049317,
          max_follow_count_growth_rate_3m: 0.17073170840740204,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 33800,
              engagement_rate_3m: 0.004055259108346518,
              follow_count_growth_rate_3m: -0.014945652335882187,
              view_rate_3m: 0.21623521058003817,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10000,
              engagement_rate_3m: 0.06963755199049317,
              follow_count_growth_rate_3m: 0.14817847311496735,
              view_rate_3m: 0,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 42000,
              engagement_rate_3m: 0.008863046757164404,
              follow_count_growth_rate_3m: 0.17073170840740204,
              view_rate_3m: 0.022827549019607842,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'brand',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo7.id,
              name: brandInfo7.name,
              kol_type: 'brand',
              rank: 2,
            },
          ],
          sponsored_rate: 0.03,
          audience_gender: Gender.Female,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-06-23T06:58:12Z',
              title_content: "I'm not to be messed with!",
              post_id: 'NAb9DsmZT3I',
              post_type: PostType.Image,
              platform_type: 0,
              thumbnail: demoPostSrc2,
              crawled_id: 'UCvw1LiGdyulhnGksJlGWB6g',
              link: 'https://www.youtube.com/watch?v=NAb9DsmZT3I',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc3,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: '7321724200497040646',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc4,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '樂於分享超商、連鎖速食店創意吃法等等影片，以幽默搞笑的短片和生活日常分享而受歡迎。',
        },
        {
          kol_uuid: kolInfo7.id,
          hash_kol_datahub_identity_id: kolInfo7.id,
          names: [kolInfo7.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'Influencer',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo7.id,
              name: brandInfo7.name,
              kol_type: 'Influencer',
              rank: 2,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo8.id,
              name: brandInfo8.name,
              kol_type: 'Influencer',
              rank: 3,
            },
          ],
          sponsored_rate: 0.1,
          audience_gender: Gender.Female,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-07-03T11:32:01Z',
              title_content: '',
              post_id: 'C89X8a-vCZ_',
              post_type: PostType.Image,
              platform_type: PlatformType.Instagram,
              thumbnail: demoPostSrc1,
              crawled_id: '3291079932',
              ig_post_id: '3403982200570127999',
              link: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '3403264375228512654',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: 'C860usCPLmO',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc3,
              crawled_id: '3291079932',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '以旅遊、美食和生活風格的內容而受歡迎，最近發布了超商隱藏調酒喝法，單支影片瀏覽量更突破 40 萬。',
        },
        {
          kol_uuid: kolInfo8.id,
          hash_kol_datahub_identity_id: kolInfo8.id,
          names: [kolInfo8.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.21623521058003817,
          max_engagement_rate_3m: 0.06963755199049317,
          max_follow_count_growth_rate_3m: 0.17073170840740204,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 23800,
              engagement_rate_3m: 0.004055259108346518,
              follow_count_growth_rate_3m: -0.014945652335882187,
              view_rate_3m: 0.21623521058003817,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 999,
              engagement_rate_3m: 0.06963755199049317,
              follow_count_growth_rate_3m: 0.14817847311496735,
              view_rate_3m: 0,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 42000,
              engagement_rate_3m: 0.008863046757164404,
              follow_count_growth_rate_3m: 0.17073170840740204,
              view_rate_3m: 0.022827549019607842,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'brand',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo8.id,
              name: brandInfo8.name,
              kol_type: 'Influencer',
              rank: 3,
            },
          ],
          sponsored_rate: 0.00123,
          audience_gender: Gender.Male,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-06-23T06:58:12Z',
              title_content: "I'm not to be messed with!",
              post_id: 'NAb9DsmZT3I',
              post_type: PostType.Image,
              platform_type: 0,
              thumbnail: demoPostSrc5,
              crawled_id: 'UCvw1LiGdyulhnGksJlGWB6g',
              link: 'https://www.youtube.com/watch?v=NAb9DsmZT3I',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc6,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: '7321724200497040646',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '樂於分享超商、連鎖速食店創意吃法等等影片，以幽默搞笑的短片和生活日常分享而受歡迎。',
        },
        {
          kol_uuid: kolInfo9.id,
          hash_kol_datahub_identity_id: kolInfo9.id,
          names: [kolInfo9.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 12973430,
          max_view_rate_3m: 0.21623521058003817,
          max_engagement_rate_3m: 0.06963755199049317,
          max_follow_count_growth_rate_3m: 0.17073170840740204,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 33800,
              engagement_rate_3m: 0.004055259108346518,
              follow_count_growth_rate_3m: -0.014945652335882187,
              view_rate_3m: 0.21623521058003817,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10000,
              engagement_rate_3m: 0.06963755199049317,
              follow_count_growth_rate_3m: 0.14817847311496735,
              view_rate_3m: 0,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 42000,
              engagement_rate_3m: 0.008863046757164404,
              follow_count_growth_rate_3m: 0.17073170840740204,
              view_rate_3m: 0.022827549019607842,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'brand',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo7.id,
              name: brandInfo7.name,
              kol_type: 'brand',
              rank: 2,
            },
          ],
          sponsored_rate: 0.03,
          audience_gender: Gender.Female,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-06-23T06:58:12Z',
              title_content: "I'm not to be messed with!",
              post_id: 'NAb9DsmZT3I',
              post_type: PostType.Image,
              platform_type: 0,
              thumbnail: demoPostSrc2,
              crawled_id: 'UCvw1LiGdyulhnGksJlGWB6g',
              link: 'https://www.youtube.com/watch?v=NAb9DsmZT3I',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc3,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: '7321724200497040646',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc4,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '樂於分享超商、連鎖速食店創意吃法等等影片，以幽默搞笑的短片和生活日常分享而受歡迎。',
        },
        {
          kol_uuid: kolInfo10.id,
          hash_kol_datahub_identity_id: kolInfo10.id,
          names: [kolInfo10.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'Influencer',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo7.id,
              name: brandInfo7.name,
              kol_type: 'Influencer',
              rank: 2,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo8.id,
              name: brandInfo8.name,
              kol_type: 'Influencer',
              rank: 3,
            },
          ],
          sponsored_rate: 0.1,
          audience_gender: Gender.Female,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-07-03T11:32:01Z',
              title_content: '',
              post_id: 'C89X8a-vCZ_',
              post_type: PostType.Image,
              platform_type: PlatformType.Instagram,
              thumbnail: demoPostSrc1,
              crawled_id: '3291079932',
              ig_post_id: '3403982200570127999',
              link: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '3403264375228512654',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: 'C860usCPLmO',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc3,
              crawled_id: '3291079932',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '以旅遊、美食和生活風格的內容而受歡迎，最近發布了超商隱藏調酒喝法，單支影片瀏覽量更突破 40 萬。',
        },
        {
          kol_uuid: brandInfo6.id,
          hash_kol_datahub_identity_id: brandInfo6.id,
          names: [brandInfo6.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.21623521058003817,
          max_engagement_rate_3m: 0.06963755199049317,
          max_follow_count_growth_rate_3m: 0.17073170840740204,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 23800,
              engagement_rate_3m: 0.004055259108346518,
              follow_count_growth_rate_3m: -0.014945652335882187,
              view_rate_3m: 0.21623521058003817,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 999,
              engagement_rate_3m: 0.06963755199049317,
              follow_count_growth_rate_3m: 0.14817847311496735,
              view_rate_3m: 0,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 42000,
              engagement_rate_3m: 0.008863046757164404,
              follow_count_growth_rate_3m: 0.17073170840740204,
              view_rate_3m: 0.022827549019607842,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'brand',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo8.id,
              name: brandInfo8.name,
              kol_type: 'Influencer',
              rank: 3,
            },
          ],
          sponsored_rate: 0.00123,
          audience_gender: Gender.Male,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-06-23T06:58:12Z',
              title_content: "I'm not to be messed with!",
              post_id: 'NAb9DsmZT3I',
              post_type: PostType.Image,
              platform_type: 0,
              thumbnail: demoPostSrc5,
              crawled_id: 'UCvw1LiGdyulhnGksJlGWB6g',
              link: 'https://www.youtube.com/watch?v=NAb9DsmZT3I',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc6,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: '7321724200497040646',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '樂於分享超商、連鎖速食店創意吃法等等影片，以幽默搞笑的短片和生活日常分享而受歡迎。',
        },
        {
          kol_uuid: brandInfo7.id,
          hash_kol_datahub_identity_id: brandInfo7.id,
          names: [brandInfo7.name],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 12973430,
          max_view_rate_3m: 0.21623521058003817,
          max_engagement_rate_3m: 0.06963755199049317,
          max_follow_count_growth_rate_3m: 0.17073170840740204,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 33800,
              engagement_rate_3m: 0.004055259108346518,
              follow_count_growth_rate_3m: -0.014945652335882187,
              view_rate_3m: 0.21623521058003817,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10000,
              engagement_rate_3m: 0.06963755199049317,
              follow_count_growth_rate_3m: 0.14817847311496735,
              view_rate_3m: 0,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 42000,
              engagement_rate_3m: 0.008863046757164404,
              follow_count_growth_rate_3m: 0.17073170840740204,
              view_rate_3m: 0.022827549019607842,
            },
          ],
          related_kols: [
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo6.id,
              name: brandInfo6.name,
              kol_type: 'brand',
              rank: 1,
            },
            {
              hash_kol_datahub_identity_id: '123_xxx_1456',
              kol_uuid: brandInfo7.id,
              name: brandInfo7.name,
              kol_type: 'brand',
              rank: 2,
            },
          ],
          sponsored_rate: 0.03,
          audience_gender: Gender.Female,
          quotations: {
            post: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
            video: {
              min_price: 20000,
              max_price: 50000,
              currency: CurrencyCode.TWD,
            },
          },
          posts: [
            {
              publish_time: '2024-06-23T06:58:12Z',
              title_content: "I'm not to be messed with!",
              post_id: 'NAb9DsmZT3I',
              post_type: PostType.Image,
              platform_type: 0,
              thumbnail: demoPostSrc2,
              crawled_id: 'UCvw1LiGdyulhnGksJlGWB6g',
              link: 'https://www.youtube.com/watch?v=NAb9DsmZT3I',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-13T16:37:49Z',
              title_content: '',
              post_id: '7323623035842415878',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc3,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
            {
              publish_time: '2024-01-08T13:49:23Z',
              title_content: '',
              post_id: '7321724200497040646',
              post_type: PostType.Image,
              platform_type: 3,
              thumbnail: demoPostSrc4,
              crawled_id: '6520609234832277506',
              link: '',
              ig_post_id: '',
            },
          ],
          recommendation_summary:
            '樂於分享超商、連鎖速食店創意吃法等等影片，以幽默搞笑的短片和生活日常分享而受歡迎。',
        },
      ],
      recommendation_type: 'potential',
    },
  }
}

const fakeBehaviorRecommendationData = makeFakeBehaviorRecommendationData()

const makeFakeKeywordRecommendationData = (
  locale?: SupportedLanguages,
): KeywordRecommendationResponse => {
  const kolInfo1 = makeKolInfo1(locale)
  const kolInfo2 = makeKolInfo2(locale)
  const kolInfo3 = makeKolInfo3(locale)
  const kolInfo4 = makeKolInfo4(locale)
  const kolInfo5 = makeKolInfo5(locale)
  const kolInfo6 = makeKolInfo6(locale)
  const kolInfo7 = makeKolInfo7(locale)
  const kolInfo8 = makeKolInfo8(locale)
  const kolInfo9 = makeKolInfo9(locale)
  const kolInfo10 = makeKolInfo10(locale)
  const brandInfo6 = makeBrandInfo6(locale)
  const brandInfo7 = makeBrandInfo7(locale)

  return {
    data: {
      kols: [
        {
          kol_uuid: kolInfo1.id,
          hash_kol_datahub_identity_id: '12345',
          names: [kolInfo1.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 123000,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.1234,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 3,
        },
        {
          kol_uuid: kolInfo2.id,
          hash_kol_datahub_identity_id: '12345',
          names: [kolInfo2.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.0234,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 4,
        },
        {
          kol_uuid: kolInfo3.id,
          hash_kol_datahub_identity_id: '12345',
          names: [kolInfo3.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 1233000,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.0234,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 5,
        },
        {
          kol_uuid: kolInfo4.id,
          hash_kol_datahub_identity_id: '12345',
          names: [kolInfo4.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 1233000,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.0234,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 5,
        },
        {
          kol_uuid: kolInfo5.id,
          hash_kol_datahub_identity_id: '12345',
          names: [kolInfo5.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 5,
        },
        {
          kol_uuid: kolInfo6.id,
          hash_kol_datahub_identity_id: kolInfo6.id,
          names: [kolInfo6.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 5,
        },
        {
          kol_uuid: kolInfo7.id,
          hash_kol_datahub_identity_id: kolInfo7.id,
          names: [kolInfo7.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 5,
        },
        {
          kol_uuid: kolInfo8.id,
          hash_kol_datahub_identity_id: kolInfo8.id,
          names: [kolInfo8.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 5,
        },
        {
          kol_uuid: kolInfo9.id,
          hash_kol_datahub_identity_id: kolInfo9.id,
          names: [kolInfo9.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 5,
        },
        {
          kol_uuid: kolInfo10.id,
          hash_kol_datahub_identity_id: kolInfo10.id,
          names: [kolInfo10.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 5,
        },
        {
          kol_uuid: brandInfo6.id,
          hash_kol_datahub_identity_id: brandInfo6.id,
          names: [brandInfo6.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 5,
        },
        {
          kol_uuid: brandInfo7.id,
          hash_kol_datahub_identity_id: brandInfo7.id,
          names: [brandInfo7.name],
          customized_tags_names: [
            'Medical and Health/Nutrition & Health Care',
            'Art and Entertainment',
            'Food',
            'Medical and Health',
            'Beauty and Fashion/Hair Beauty',
          ],
          links: [
            {
              platform_type: PlatformType.Instagram,
              type: PlatformShortcode.Instagram,
              url: '',
            },
            {
              platform_type: PlatformType.Facebook,
              type: PlatformShortcode.Facebook,
              url: '',
            },
            {
              platform_type: PlatformType.YouTube,
              type: PlatformShortcode.YouTube,
              url: '',
            },
          ],
          total_follow_count: 33300,
          max_view_rate_3m: 0.15,
          max_engagement_rate_3m: 0.05,
          max_follow_count_growth_rate_3m: 0.02,
          kpi: [
            {
              platform: PlatformShortcode.Instagram,
              follow_count: 13800,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.Facebook,
              follow_count: 10900,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
            {
              platform: PlatformShortcode.YouTube,
              follow_count: 32000,
              engagement_rate_3m: 0.1992,
              follow_count_growth_rate_3m: 0.02,
              view_rate_3m: 0.15,
            },
          ],
          matched_posts: [
            {
              publish_time: '2024-07-08T02:19:49Z',
              title_content:
                '終於留到剪下15公分 👍🏼打算留做紀念，到超商聯名的咖啡廳和好姐妹喝個下午茶，最後拍照留念。...',
              post_id: 'C9JQl2SyOqp',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc1,
              crawled_id: '869278299',
              ig_post_id: '3407327562744523433',
              link: '',
            },
            {
              publish_time: '2024-07-07T14:11:48Z',
              title_content:
                '韓國咖啡廳巡禮，不得不說韓國人真的很會開店，超商聯名的咖啡廳還以為是去看展覽，每個角落都超...',
              post_id: 'C9H8zAxS65D',
              post_type: PostType.Short,
              platform_type: 3,
              thumbnail: demoPostSrc2,
              crawled_id: '869278299',
              ig_post_id: '3406959031440092739',
              link: '',
            },
            {
              publish_time: '2024-07-07T12:05:00Z',
              title_content:
                '誰跟我一樣也是每天一杯黑咖啡，最新的超商聯名聽說這是韓妞的瘦身密技，走在路上她們真的是人手一杯...',
              post_id: '974454391358066',
              post_type: PostType.Short,
              platform_type: 1,
              thumbnail: demoPostSrc1,
              crawled_id: '1704836209838705',
              ig_post_id: '974454391358066',
              link: '',
            },
          ],
          matched_post_count: 5,
        },
      ],
      keywords: ['咖啡廳', '韓國人'],
    },
  }
}

const fakeKeywordRecommendationData = makeFakeKeywordRecommendationData()

export {
  fakeBehaviorRecommendationData,
  fakeKeywordRecommendationData,
  mockEmptyPostList,
}
